import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { UserGroupAccess } from '../../interfaces/user-group-access';
import { REG_HUB_COMMON_CONFIG, RegHubCommonConfig } from '../../reg-hub-common-config';
import { SelectOption } from '../../interfaces/select-option';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserGroupAccessRepositoryService {

  constructor(
    private http: HttpClient,
    @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig) {}

  // CRUD Operations ---------------
  public getUserGroupAccess = (route: string, userGroupAccessID: string) => {
    return this.http.get<UserGroupAccess>(
      this.createCompleteRoute(route + "/" + userGroupAccessID, this.config.rootUrl));
  }

  public getUserGroupAccesses = (route: string) => {
    return this.http.get<UserGroupAccess[]>(
      this.createCompleteRoute(route, this.config.rootUrl));
  }

  private mapUserGroupAccessToSelectOption(type: UserGroupAccess): SelectOption {
      return { label: type.hasAccessToUserGroup!.name, value: type.hasAccessToUserGroup!.id };
    }

  public getReadableUserAccesses = () => {
      return this.http.get<UserGroupAccess[]>(
        this.createCompleteRoute(`UserGroupAccess?PageSize=100&sortColumn=UserGroup.Name&CanRead=true&isUserGroupActive=true`, this.config.rootUrl)
      );
  }

  public getReadableUserAccessesAsSelectOptions = () => {
      return this.getReadableUserAccesses().pipe(map(types => types.map(this.mapUserGroupAccessToSelectOption)));
  }

  public getWriteableUserAccesses = () => {
      return this.http.get<UserGroupAccess[]>(
        this.createCompleteRoute(`UserGroupAccess?PageSize=100&sortColumn=UserGroup.Name&CanWrite=true&isUserGroupActive=true`, this.config.rootUrl)
      );
  }

  public getWriteableUserAccessesAsSelectOptions = () => {
      return this.getWriteableUserAccesses().pipe(map(types => types.map(this.mapUserGroupAccessToSelectOption)));
  }

  public createUserGroupAccess = (route: string, userGroup: UserGroupAccess) => {
    return this.http.post<UserGroupAccess>(
      this.createCompleteRoute(route, this.config.rootUrl),
      userGroup,
      this.generateHeaders());
  }

  public updateUserGroupAccess = (route: string, userGroup: UserGroupAccess) => {
    return this.http.put(this.createCompleteRoute(route, this.config.rootUrl), userGroup, this.generateHeaders());
  }
  public deleteUserGroupAccess = (route: string) => {
    return this.http.delete(this.createCompleteRoute(route, this.config.rootUrl));
  }
  //-------------------------------

  private createCompleteRoute = (route: string, envAddress: string) => {
    return `${envAddress}/${route}`;
  }

  private generateHeaders = () => {
    return {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
  }
}
